import { axiosService } from '@services'

import { API } from '../endPoints'

export default async function getSummaryDashboard(dashboardId: string) {
  return axiosService({ method: 'GET', apiPath: `${API.ADMIN_DASHBOARD}/${dashboardId}` })
}
